angular.module('notification', ['ui.router','confirm.modal.html', 'ngResource', 'ngTable', 'ui.bootstrap']);

angular.module('notification').config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {

    $stateProvider
    .state('notification', {
        url         : "/notification",
        templateUrl : server+"/views/m/notification",
        controller  : 'notification.list',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'home',
            label: 'Notification'
        }
    })

    .state('notification_create', {
        url         : "/notification/create",
        templateUrl : server+"/views/m/notification/create",
        controller  : 'notification.create',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'notification',
            label: 'Adicionar'
        }
    })

    .state('notification_show', {
        url         : "/notification/:id",
        templateUrl : server+"/views/m/notification/show",
        controller  : 'notification.show',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'notification',
            label: '{{notification.id}}'
        }
    })

}]);

/**
 * List Controller
 */
angular.module('notification').
controller('notification.list', ['$scope', '$http', '$auth', '$q', 'NgTableParams', '$notification', function($scope, $http, $auth, $q, NgTableParams, $notification) {
    $scope.tableParams = new NgTableParams({
        page: 1,
        count: 10
    }, {
        counts: [],
        filterDelay: 0,
        getData: function(params) {
            return $notification.query(params.url()).$promise.then(function(data) {
                params.total(data.total);
                return data.data;
            });
        }
    });
}]);

/**
 * Create Controller
 */
angular.module('notification').
controller('notification.create', ['$scope', '$state', '$notification', function($scope, $state, $notification) {
    $scope.save = function() {
        $notification.save($scope.notification).$promise.then(function(data) {
            $state.go('notification_show', {
                id: data.id
            });
        });
    }
}]);

/**
 * Show, Edit, Delete Controller
 */
angular.module('notification').
controller('notification.show', ['$state', '$scope', '$stateParams', '$uibModal', '$notification', function($state, $scope, $stateParams, $uibModal, $notification) {

    $scope.editing = false;

    $scope.toggleEdit = function() {
        $scope.editing = !$scope.editing;
    }

    $notification.get({
        id: $stateParams.id
    }).$promise.then(function(data) {
        $scope.notification = data;
    }, function(error) {
        if (error.status == 404) {
            $state.go('notFound');
        }
    });

    $scope.confirmUpdate = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$scope', '$uibModalInstance', '$notification', function($scope, $uibModalInstance, $notification) {

                $scope.title = 'Deseja atualizar?';
                $scope.cancel_text = 'Cancelar';
                $scope.success_text = 'Concluído';

                var notification = $scope.$parent.notification;

                $scope.confirm = function() {
                    $notification.update({
                        id: notification.id
                    }, notification).$promise.then(function(data) {
                        $uibModalInstance.dismiss('cancel');
                        $scope.$parent.toggleEdit();
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

    $scope.confirmDelete = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$state', '$scope', '$uibModalInstance', '$notification', function($state, $scope, $uibModalInstance, $notification) {

                $scope.title = 'Deseja remover esse registro?';
                $scope.cancel_text = 'Não';
                $scope.success_text = 'Sim';

                var notification = $scope.$parent.notification;

                $scope.confirm = function() {
                    $notification.delete({id:notification.id}).$promise.then(function(data){
                        $uibModalInstance.dismiss('cancel');
                        $state.go('notification');
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

}]);


/**
 * Factory
 */
angular.module('notification').
factory("$notification", [ '$resource', function($resource) {
    var resource = $resource(api + 'notification/:id', null, {
        'query': {
            method: 'GET',
            isArray: false
        },
        'update': {
            method: 'PUT'
        }
    });
    return resource;
}]);

angular.module("confirm.modal.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put('confirm.modal.html',
        '<div class="modal-body">' +
        ' {{title}}' +
        '</div>' +
        '<div class="modal-footer">' +
        '    <button class="btn btn-link btn-info" type="button" ng-click="cancel()">{{cancel_text}}</button>' +
        '    <button class="btn btn-outline btn-success" type="button" ng-click="confirm()">{{success_text}}</button>' +
        '</div>'
    );
}]);
